let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");

let has_tip_been_shown = false;

module.exports = dd.createClass({
	getInitialState(){
		return {show_tip: !has_tip_been_shown};
	},
	__closeTip: esUtils.wrapPreventDefault(function(){
		has_tip_been_shown = true;
		this.setState({show_tip: false});
	}),
	render(){
		let {Displaylists, url_args} = this.props;
		let tip = Displaylists && Displaylists.tip || {};
		if(!_.isString(tip && tip.tiptext)){
			return dd.span();//Displaylists must not be loaded yet
		}
		if(/^jobs$/i.test(_.first(url_args))){
			return dd.span();//Displaylists
		}

		if(this.state.show_tip && (tip.priority >= 8)){//only show if it's critical
		}else{
			return dd.span();
		}

		return Modal({
				title: "Tip of the day",
				buttons: [],
				onClose: this.__closeTip
			},
			dd.div({className: "row"},
				dd.div({className: "col-sm-3 text-center text-muted"},
					dd.i({
						className: tip.priority >= 8 ? "fa fa-warning text-danger" : "fa fa-lightbulb-o",
						style: {fontSize: 100}
					})
				),
				dd.div({className: "col-sm-9"},
					dd.p({className: "preserve-whitespace"}, tip.tiptext.trim()),
					tip.link ? dd.p(null,
						dd.a({href: tip.link, target: "_blank"}, tip.linktext || tip.link)
					) : null
				)
			),
			dd.div({className: "text-center"},
				dd.button({className: "btn btn-primary", onClick: this.__closeTip}, "Ok")
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/modals/TipOfTheDay.js